/**
 * This is the JS file for the Promo Links on the website.
 * 
 * The first functions will catch the promo in the query string and store it
 * in the local storage
 */

var promoObj = null;

$(document).ready(function() {
  if (location.search) {
    var params = location.search.split("?")[1].split("&");
    for (var i in params) {
      var keyValue = params[i].split('=');
      if (keyValue[0] === 'promo') {
        if (keyValue[1] !== null && typeof keyValue[1] !== 'undefined') {
          localStorage.setItem('promo', keyValue[1]);
        }
        break;
      }
    }
  }
  getPromoDetail(localStorage.getItem('promo'));
});

function getPromoDetail(id) {
  if (id){
    $.ajax({
      url: '/wp-content/themes/mention/scripts/wp-promolinks.php?promo_id=' + id,
      type: 'GET',
      dataType: 'json',
      headers: {
        "accept": "application/json"
      },
      success: function(dataResponse){
        promoObj = dataResponse;
        console.log(promoObj);
        detectPromoObj();
      },
      error: function(xhr, status, error) {
        var obj = $.parseJSON(xhr.responseText);
        var errorMsg = obj.message;
        console.log(errorMsg);
      }
    });
  }
}

/*
Here we will display the alert messages if the PromoObj object and the
Signup Message property exist.
*/

function detectPromoObj() {
  if (promoObj) {
    if (promoObj.promolink.signup_message) {
      addPromoInfos();
    }
  }
}

function addPromoInfos() {
  var messageTitle = 'Hey there looks like you have a promo code :';
  var messageSubTitle = promoObj.promolink.signup_message;
  var messageDetail = 'Use your promotion now';
  var messageLogin = 'Hey there looks like you have a promo code :)';

  // is the announcement module in place?
  if ($('.men__announcement-cont').length) {
    addPopupMain();
    $('.men__announcement').removeClass('hidden');
    $('.men__announcement').addClass('visible-left--flex');
    $('.men__announcement--main .men__announcement-alert-title').text(messageTitle);
    $('.men__announcement--main .men__announcement-alert-subtitle').text(messageSubTitle);
    $('.men__announcement--main .men__announcement-alert-login').text(messageLogin);
  }

  // Is the main CTA on home in place?
  if ($('.men__home-form-top').length) {
    $('.men__home-top-cta').text(messageDetail);
  }
}

function addPopupMain() {
  console.log("promo notif");

  var popupHTML = '<div class="men__announcement men__announcement--main hidden"><div class="men__announcement-logo hidden"><img class="men__announcement-logo--ph" src="/wp-content/themes/mention/img/ph.png" alt=""></div><a href="./signup" class="men__announcement-alert-container"><p class="men__announcement-alert-title"></p><p class="men__announcement-alert-subtitle"></p></a><span class="men__announcement-close men__announcement-close--main">x</span></div>';

  $('.men__announcement-cont').append(popupHTML);

  $('.men__announcement-close--main').on('click', function() {
    var closestPopup = $('.men__announcement--main');
    closestPopup.removeClass('visible-left--flex');
    closestPopup.addClass('hidden');
  });
}
